import React, { useEffect, useContext, useState, useMemo } from "react";
import {
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from "@coreui/react";
import api from "../services/config.url";
import showPopup from "../components/PopUp";
import AuthContext from "../contexts/auth";
import HistoricIcon from '../assets/images/order-history.png';
import ConfirmationModal from "../components/modal/modalConfirmation";
import { downloadMateria } from "../services/downloadPdf";
import { setDownloadLoading } from "../services/downloadLoading";

const BooksAcquiredList = (props) => {
    const { cart, setLoading, setSizeCart, user } = useContext(AuthContext);
    const [orders, setOrders] = useState([]);
    const sizeCart = useMemo(() => cart?.items?.length, [cart]);
    const [isLoadingContainer, setIsLoadingContainer] = useState(false);
    const [isOpenConfirmation, setIsOpenConfirmation] = useState(false);
    const [itemToAddHistory, setItemToAddHistory] = useState({});
    const isPremium = !!(
      user?.subscriptionExpiresAt && new Date(user.subscriptionExpiresAt) > new Date()
    );

    useEffect(() => {
      if (!cart) return;
      setSizeCart(sizeCart);
      setIsLoadingContainer(true);
      const fetchData = async () => {
        try {
          const response = await api.get(
            isPremium
              ? `/customers/products/full-catalog`
              : `/customers/orders/customer-products`
          );
          setOrders(response.data.items);
        } catch (error) {
          const BackendError = error?.response?.data?.message;
          const genericError = "Erro ao listar os cadernos adquiridos";
          showPopup(BackendError || genericError, "error");
        } finally {
          setIsLoadingContainer(false);
        }
      };
      fetchData();
    }, [cart, isPremium]);
  
    const handleDownloadCloud = async (obj) => {
        const sku = obj.sku || obj?.parent?.sku;
        const { name, secondName, document: documentCustomer } = user || {};

      if (!name) {
        showPopup(
          "O campo Nome é obrigatório! Acesse seu perfil para preenchê-lo.",
          "error"
        );
        return;
      }
      if (!documentCustomer) {
        showPopup(
          "O campo CPF é obrigatório! Acesse seu perfil para preenchê-lo.",
          "error"
        );
        return;
      }
      try {
        setDownloadLoading(true);
        const response = await api.post(
          `/customers/products/cloud-pdf`,
          {
            sku,
            customerName: [name, secondName].filter(Boolean).join(" "),
            customerCPF: documentCustomer,
          },
          { "Content-Type": "application/pdf" }
        );
        const pdfUrl = response.data.downloadUrl;
        // aguarda o download de fato antes de fechar o modal de loading
        const fileResponse = await fetch(pdfUrl);
        if (!fileResponse.ok) {
          throw new Error("Erro ao baixar o arquivo");
        }
        const blob = await fileResponse.blob();
        saveAs(blob, `${response.data.fileName}.pdf`);
      } catch (error) {
        const BackendError = error?.response?.data?.message;
        const genericError = "Erro ao baixar os arquivos";
        showPopup(BackendError || genericError, "error");
      } finally {
        setDownloadLoading(false);
      }
    };

  // Regra da matéria: se tiver subcadernos, baixa todos; senão, baixa a
  // própria matéria. Para não-premium, pula os que já foram baixados
  // (downloadedAt setado); premium sempre vem com downloadedAt null.
  const materiaAllDownloaded = (parent) => {
    const children = parent?.items || [];
    if (children.length > 0) return children.every((c) => c?.downloadedAt);
    return !!parent?.downloadedAt;
  };

  const handleMateriaDownload = async (parent) => {
    const children = parent?.items || [];
    if (children.length > 0) {
      const pending = children.filter((c) => !c?.downloadedAt);
      if (pending.length === 0) {
        showPopup(
          "Todos os cadernos desta matéria já foram baixados.",
          "alert"
        );
        return;
      }
    }
    // Uma chamada só → .zip (matéria com filhos) ou PDF simples (sem filhos).
    await downloadMateria(parent, user, setLoading, children);
  };

  const handleCancel = () => {
    setIsOpenConfirmation(false);
  };

  const handleAddHistoric = async () => {
    try {
    const {parent, orderId, sku, name, _id} = itemToAddHistory ?? {}

    let payload = {
      type: "REVISION",
      product: parent?._id || _id || null,
      parent: null,
      sku: parent?.sku || sku,
      name: parent?.name || name,
      currentDate: new Date(),
      observation: 'Registro criado através da listagem de pedidos',
      bought: true,
      color: null,
      hidden: false,
      orderId: orderId
    };

    await api.post(`/customers/revisions-book/historic/${_id}`, payload);
    showPopup('CAD adicionado ao histórico', "success");
    handleCancel()
  } catch (error) {
    const BackendError = error?.response?.data?.message;
    const genericError = "Erro ao criar o histórico do caderno no painel";
    showPopup(BackendError || genericError, "error");
  }
  }

  
  return (
    <>
   <CAccordion>
        <CAccordionItem itemKey={1}>
          <div className="table-responsive">
            <div className="table check-tbl">
              <CAccordionHeader className="bg-my-books-collapse">
                <div className="title-of-table ">
                  <div>MEUS CADERNOS</div>
                </div>
              </CAccordionHeader>
              <CAccordionBody className="p-0">
                <div className="lines-of-table">
                  {orders && orders?.length < 1 ? (
                    !isLoadingContainer ? (
                      <div className="p-3">
                        Você não possui nenhum pedido com status de pagamento
                        aprovado.
                      </div>
                    ) : (
                      <div className="loadingContainer m-3"></div>
                    )
                  ) : (
                    <CAccordion>
                      {orders.map((order, index) => (
                        <CAccordionItem
                          itemKey={index}
                          key={index}
                          className="p-0"
                        >
                          <React.Fragment key={index}>
                            <CAccordionHeader
                              className={
                                (order?.parent.items?.length < 1)
                                  ? "removeIcon espacinho"
                                  : ""
                              }
                            >
                              <div className="d-flex justify-content-between w-100">
                                <div>
                                  {order?.parent ? (
                                    <React.Fragment>
                                      {order?.parent?.sku} -{" "}
                                      {order.parent?.name}
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      <div
                                        style={{
                                          marginBottom: "9px",
                                          marginTop: "4px",
                                        }}
                                      >
                                        {order?.parent.name}
                                      </div>
                                    </React.Fragment>
                                  )}
                                </div>
                                <div className="ml-auto m-r20 p-l10">
                                  {/* Download da MATÉRIA: se tiver subcadernos,
                                      baixa todos; senão, baixa a própria matéria. */}
                                  <div style={{ display: 'flex', alignItems: 'center'}}>
                                    <input
                                      type="button"
                                      disabled={materiaAllDownloaded(order.parent)}
                                      onClick={() => handleMateriaDownload(order.parent)}
                                      className="d-flex justify-content-center downloadPdfBtn btn btn-primary btnhover max-w100 p-2"
                                      target="_blank"
                                      style={{
                                        alignItems: "center",
                                        opacity: materiaAllDownloaded(order.parent) ? 0.5 : 1,
                                        cursor: materiaAllDownloaded(order.parent)
                                          ? "not-allowed"
                                          : "pointer",
                                      }}
                                      value={
                                        materiaAllDownloaded(order.parent)
                                          ? "Já baixado"
                                          : (order?.parent?.items?.length > 0
                                              ? "Baixar tudo"
                                              : "Download")
                                      }
                                      />
                                    <div className="m-l10">
                                        <img src={HistoricIcon} style={{ cursor: 'pointer '}} alt="ICO" width={24} height={24} onClick={() => {
                                          setIsOpenConfirmation(true)
                                          setItemToAddHistory({...order, orderId: order._id})
                                          }}/>
                                      </div>
                                    </div>
                                </div>
                              </div>
                            </CAccordionHeader>
                            <CAccordionBody className="p-0">
                              {order?.parent?.items && order?.parent?.items.length > 0 ? (
                                <React.Fragment>
                                  {order?.parent?.items?.map((child, index) => (
                                    <React.Fragment key={index}>
                                      <div className="p-3 flex-my-books">
                                        <div className="product-item-name item-1">
                                          {child?.parent?.parent ? (
                                            <React.Fragment>
                                              {child?.sku} - {child?.name}
                                            </React.Fragment>
                                          ) : (
                                            <React.Fragment>
                                              {child?.sku} - {child?.name}
                                            </React.Fragment>
                                          )}
                                        </div>
                                        <div className="item-3" style={{ display: 'flex', alignItems: 'center'}}>
                                          <input
                                            type="button"
                                            disabled={!!child?.downloadedAt}
                                            onClick={() =>
                                              handleDownloadCloud(child)
                                            }
                                            className="d-flex justify-content-center downloadPdfBtn btn btn-primary btnhover max-w100 p-2"
                                            target="_blank"
                                            style={{
                                              opacity: child?.downloadedAt ? 0.5 : 1,
                                              cursor: child?.downloadedAt
                                                ? "not-allowed"
                                                : "pointer",
                                            }}
                                            value={
                                              child?.downloadedAt
                                                ? "Já baixado"
                                                : "Download"
                                            }
                                          />
                                          <div className="m-l10">
                                          <img src={HistoricIcon} style={{ cursor: 'pointer '}} alt="ICO" width={24} height={24} onClick={() => {
                                            setIsOpenConfirmation(true)
                                            setItemToAddHistory({...child, orderId: order._id})
                                            }}/>
                                        </div>
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  ))}
                                </React.Fragment>
                              ) : (
                                <React.Fragment></React.Fragment>
                              )}
                            </CAccordionBody>
                          </React.Fragment>
                        </CAccordionItem>
                      ))}
                    </CAccordion>
                  )}
                </div>
                <ConfirmationModal
                  message={"Registrar o estudo do CAD no HISTÓRICO?"}
                  onConfirm={handleAddHistoric}
                  onCancel={handleCancel}
                  isModalOpen={isOpenConfirmation}
                />
              </CAccordionBody>
            </div>
            <div></div>
          </div>
        </CAccordionItem>
      </CAccordion>
    </>
  );
};

export default BooksAcquiredList;
